
import {Bar, Line} from 'react-chartjs-2';
import {Boxdataset} from './boxdataset';
import React, { useMemo } from 'react';


export const SidebarMainHousing = ({exportInd, housing_seasonality, housing_buy, housing_rent, type_industry}) => {

    const line_chart = () => {
        return {
         labels: ['2013', '2014', '2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022', '2023'],
         datasets: [
           {
             label: 'Housing Buy Data',
             fill: false,
             lineTension: 0.5,
             background: '#ffffff',
             borderColor: 'rgba(0,0,0,1)',
             borderWidth: 2,
             data: housing_buy.nums
           }
         ]
       }
    }

    const housingBuyData = useMemo(() => {
      if (!housing_buy?.nums || housing_buy.nums.length < 11) {
        return {
          totalDiff: 0,
          totalCurrent: "$0",
          totalPast: "$0"
        };
      }
  
      const current = housing_buy.nums[10];
      const past = housing_buy.nums[0];
      const diff = past !== 0 ? (current - past) / past : 0;
  
      return {
        totalDiff: diff,
        totalCurrent: `$${current}`,
        totalPast: `$${past}`
      };
    }, [housing_buy]);
  
    // Memoized calculations for housing rent data
    const housingRentData = useMemo(() => {
      if (!housing_rent || housing_rent.length < 11) {
        return {
          totalDiff: 0,
          totalCurrent: "$0",
          totalPast: "$0"
        };
      }
  
      const current = housing_rent[10];
      const past = housing_rent[2];
      const diff = past !== 0 ? (current - past) / past : 0;
  
      return {
        totalDiff: diff,
        totalCurrent: `$${current}`,
        totalPast: `$${past}`
      };
    }, [housing_rent]);

    const line_chart_Buy_type = () => {
        let buy_now = housing_buy.buy_now ? Object.values(housing_buy.buy_now) : [0, 0, 0, 0, 0, 0];
        let buy_previous = housing_buy.buy_previous ? Object.values(housing_buy.buy_previous) : [0, 0, 0, 0, 0, 0];
        return {
         labels: ['1 Bedroom', '2 Bedroom', '3 Bedroom', '4 Bedroom', '5 Bedroom', 'Condos'],
         datasets: [
          {
            label: 'Housing Buy Previous',
            borderWidth: 1,
            backgroundColor: 'rgba(247,144,9,1)',
            borderColor: 'rgba(247,144,9,1)',
            hoverBackgroundColor: 'rgba(247,144,9,0.7)',
            hoverBorderColor: 'rgba(247,144,9, .5)',
            borderWidth: 2,
            data: buy_previous
          },
           {
             label: 'Housing Buy Current',
             borderColor: 'rgba(0,38,62,1)',
             borderWidth: 1,
             backgroundColor: 'rgba(21,112,239, 1)',
             borderColor: 'rgba(21,112,239, 1)',
             borderWidth: 1,
             hoverBackgroundColor: 'rgba(21,112,239, .7)',
             data: buy_now
           }
         ]
       }
      }
    const line_chart_rent = () => {
        return {
          labels: ['2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022', '2023'],
          datasets: [
            {
              label: 'Housing Rent Data',
              fill: false,
              lineTension: 0.5,
              background: '#ffffff',
              borderColor: 'rgba(0,0,0,1)',
              borderWidth: 2,
              data: housing_rent.slice(2)
            }
          ]
        } 
      }
    
    const line_chart_seasonality = () => {
        return {
         labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
         datasets: [
           {
             label: 'Housing Price Seasonality',
             fill: false,
             lineTension: 0.5,
              backgroundColor: 'rgba(21,112,239, 1)',
              borderColor: 'rgba(21,112,239, 1)',
              borderWidth: 1,
              hoverBackgroundColor: 'rgba(21,112,239, .7)',
    
             
             data: housing_seasonality ? housing_seasonality.map((e, index) => (index <= 3) ? Math.round(e * .95): e): []
           }
         ]
       }
      }
    return (
        <div className="sidebar-realestate-total" >
        {exportInd &&               <h2 className='mb-20 mt-100 font-weight600 data-component'>Residential Real Estate</h2>}
        <div className="boxdata-header data-component">Housing Data</div>
        <div className='display-flex gap-20 data-component'>
          <Boxdataset exportInd={exportInd} classnameval="box-container" margin={167}  top_text='Housing Cost' mid_text="Avg. Cost of house" total_diff={housingBuyData.totalDiff} total_current={housingBuyData.totalCurrent} total_past={housingBuyData.totalPast} type={type_industry} description="Average cost of house in the target region. Average based on research data on the Zipcode level. Previous Period: 2012" filters={{}}/>
          <Boxdataset exportInd={exportInd} classnameval="box-container" margin={167}  top_text='Housing Rental' mid_text="Avg. Cost of rent" total_diff={housingRentData.totalDiff} total_current={housingRentData.totalCurrent} total_past={housingRentData.totalPast}  type={type_industry} description="Average cost of rent in the target region. Average based on reasearch data of all regions on the county level. Previous Period: 2014" filters={{}}/>
        </div>
        {(type_industry) &&
            <div><div className="boxdata-header  data-component">Housing Cost</div>
            <div className='data-component' style={{background:"#ffffff"}}>
            <Line data={line_chart()} className='graphs-container-main'/>
            </div>
            <div className="boxdata-header">Housing Cost Segment</div>
            <div className='' style={{background:"#ffffff"}}>
            <Bar data={line_chart_Buy_type()} className='graphs-container-main'/>
            </div>
            <div className="boxdata-header">Housing Seasonality</div>
            <div className='' style={{background:"#ffffff"}}>
            <Bar data={line_chart_seasonality()} className='graphs-container-main' />
            </div>
            <div className="boxdata-header ">Housing Rental</div> 
            <div className='' style={{background:"#ffffff"}}>
            {(housing_rent[10])?
            <Line data={line_chart_rent()} className='graphs-container-main'/>:null}
            </div> 
        </div> }
      </div>
    )
}